import React from "react";
import { SvgProps } from "./Form";

export const SmallDoubleDownArrow = (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.35348 8.40547L4.64648 9.11247L7.29298 11.759C7.48051 11.9464 7.73482 12.0518 7.99998 12.0518C8.26515 12.0518 8.51946 11.9464 8.70698 11.759L11.3535 9.11247L10.6465 8.40547L7.99998 11.05L5.35348 8.40547Z"
      fill="currentColor"
    />
    <path
      d="M5.35348 4.9054L4.64648 5.6124L7.64648 8.6124C7.74025 8.70613 7.8674 8.75879 7.99998 8.75879C8.13257 8.75879 8.25972 8.70613 8.35348 8.6124L11.3535 5.6124L10.6465 4.9054L7.99998 7.5499L5.35348 4.9054Z"
      fill="currentColor"
    />
  </svg>
);
